const API = {
  GET_EXPERT_CERTIFICATES: {
    path: '/certificates/expert',
    method: 'GET',
  },
  ISSUE_SESSION_CERTIFICATE: {
    path: '/certificates/issue',
    method: 'POST',
  },
  BULK_ISSUE_SESSION_CERTIFICATE: {
    path: '/certificates/session/bulk',
    method: 'POST',
  },
  REVOKE_CERTIFICATE: {
    path: '/certificates/revoke',
    method: 'POST',
  },
  REINSTATE_CERTIFICATE: {
    path: '/certificates/reinstate',
    method: 'POST',
  },
};

export default API;
